var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_5172)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8126 35.1338L12.841 27.059L22.1241 23.2265C22.3498 23.133 22.4578 22.8748 22.3643 22.6491C22.2714 22.422 22.0132 22.314 21.7854 22.4084L12.5243 26.2337L7.34859 20.2823L41.3375 15.3548L12.8126 35.1338ZM43.5481 14.484C43.4734 14.2926 43.2759 14.1794 43.0728 14.2077L6.41777 19.5226C6.25785 19.5464 6.12155 19.6546 6.06606 19.8078C6.00979 19.959 6.041 20.1291 6.14722 20.2508L11.9553 26.9283L11.925 35.9795C11.9245 36.1439 12.0143 36.2942 12.1608 36.3723L12.1864 36.3839C12.326 36.4469 12.4913 36.4341 12.6186 36.3458L43.3892 15.0107C43.5573 14.8928 43.6242 14.6762 43.5481 14.484Z",
    fill: "#2E7161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_5172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8156,
    height: 34.3782,
    fill: "white",
    transform: "translate(14.1475) rotate(24.3008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.7325168d014fa0cff4d8471eea6e8c41.svg";
export { ForwardRef as ReactComponent };